var render = function render(){var _vm=this,_c=_vm._self._c;return _c('after-sales',{attrs:{"type":"return","after-sales-number":_vm.returnNumber}})
}
var staticRenderFns = []

export { render, staticRenderFns }